import * as R from 'radash'

export function truncateMiddle(
  string: string,
  frontLength: number,
  backLength: number,
  truncateString: string = '…',
): string {
  if (!string) {
    return ''
  }

  const stringLength = string.length

  if (
    (frontLength === 0 && backLength === 0) ||
    frontLength >= stringLength ||
    backLength >= stringLength ||
    frontLength + backLength >= stringLength
  ) {
    return string
  } else if (backLength === 0) {
    return string.slice(0, frontLength) + truncateString
  } else {
    return (
      string.slice(0, frontLength) +
      truncateString +
      string.slice(stringLength - backLength)
    )
  }
}

export const capitalize = (str: string) => R.capitalize(str)

export const truncate = (
  str: string,
  maxLength: number,
  truncateString: string = '…',
): string => {
  if (maxLength <= 0) {
    return ''
  }
  if (str.length <= maxLength) {
    return str
  }
  return str.slice(0, maxLength - 1) + truncateString
}

export const truncateEnd = (string: string, options: { maxLength: number }) =>
  string.length > options.maxLength
    ? string.slice(0, options.maxLength) + '…'
    : string
